import { generatePath } from 'react-router-dom';
import { aclRolesMap, projectPagesMap } from '../constants';
import { routesNames } from '../routes';

export const isDarkColor = (color: string): boolean => {
  if (color.startsWith('#')) {
    color = color.substring(1);
    if (color.length === 3) {
      color = color
        .split('')
        .map((c) => c + c)
        .join('');
    }

    color = parseInt(color, 16).toString(10);
  }

  const colorInt = parseInt(color, 10);
  let r: number = (colorInt >> 16) & 0xff;
  let g: number = (colorInt >> 8) & 0xff;
  let b: number = (colorInt >> 0) & 0xff;

  // calculate the luminance
  let luminance: number = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // return true if the luminance is below a threshold (dark color), otherwise false (light color)
  return luminance < 128;
};

export const getWorkspaceSideNavItems = ({ workspaceId, displayEntitiesTab, includeByDisplayName }: any) => {
  const items = [
    {
      displayName: projectPagesMap.ETL.displayName,
      slug: projectPagesMap.ETL.slug,
      url: generatePath(routesNames.workspaceTemplatesEdit, {
        projectId: workspaceId,
        slug: projectPagesMap.ETL.slug,
      }),
      accessRoles: [aclRolesMap.DATA_ADMIN],
    },
    // {
    //   displayName: projectPagesMap.DATA.displayName,
    //   slug: projectPagesMap.DATA.slug,
    //   accessRoles: [aclRolesMap.DATA_ADMIN],
    //   url: generatePath(routesNames.workspaceTemplatesEdit, {
    //     projectId: workspaceId,
    //     slug: projectPagesMap.DATA.slug,
    //   }),
    //   submenu: {
    //     component: <WorkspaceDataSectionNav workspaceId={workspaceTemplateData?.ID} />,
    //     accessRoles: [aclRolesMap.DATA_ADMIN],
    //   },
    // },
    {
      displayName: projectPagesMap.QUERIES.displayName,
      slug: projectPagesMap.QUERIES.slug,
      url: generatePath(routesNames.workspaceTemplatesEdit, {
        projectId: workspaceId,
        slug: projectPagesMap.QUERIES.slug,
      }),
      accessRoles: [aclRolesMap.DATA_ADMIN],
    },
    {
      displayName: projectPagesMap.TEMPLATES.displayName,
      slug: projectPagesMap.TEMPLATES.slug,
      url: generatePath(routesNames.workspaceTemplatesEdit, {
        projectId: workspaceId,
        slug: projectPagesMap.TEMPLATES.slug,
      }),
      accessRoles: [aclRolesMap.DATA_ADMIN],
    },
    {
      displayName: projectPagesMap.UPLOADED_DATA.displayName,
      slug: projectPagesMap.UPLOADED_DATA.slug,
      url: generatePath(routesNames.workspaceTemplatesEdit, {
        projectId: workspaceId,
        slug: projectPagesMap.UPLOADED_DATA.slug,
      }),
      accessRoles: [aclRolesMap.DATA_ADMIN],
    },
    {
      displayName: projectPagesMap.BLOCKS.displayName,
      slug: projectPagesMap.BLOCKS.slug,
      url: generatePath(routesNames.workspaceTemplatesEdit, {
        projectId: workspaceId,
        slug: projectPagesMap.BLOCKS.slug,
      }),
      accessRoles: [aclRolesMap.DATA_ADMIN],
    },
    {
      displayName: projectPagesMap.WORKSPACE_SETTINGS.displayName,
      slug: projectPagesMap.WORKSPACE_SETTINGS.slug,
      url: generatePath(routesNames.workspaceTemplatesEdit, {
        projectId: workspaceId,
        slug: projectPagesMap.WORKSPACE_SETTINGS.slug,
      }),
      accessRoles: [aclRolesMap.DATA_ADMIN],
    },
  ];

  if (displayEntitiesTab) {
    items.push({
      displayName: projectPagesMap.ENTITIES.displayName,
      slug: projectPagesMap.ENTITIES.slug,
      url: generatePath(routesNames.workspaceTemplatesEdit, {
        projectId: workspaceId,
        slug: projectPagesMap.ENTITIES.slug,
      }),
      accessRoles: [aclRolesMap.DATA_ADMIN],
    });
  }

  if (includeByDisplayName?.length) {
    return items.filter((item) => includeByDisplayName.includes(item.displayName))
  }

  return items;
};
